import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/withdrawal";

export const List = async (values) => {
    return await axiosInstance(options).post(`${path}/list-astrologers`, values);
}

export const ListAstrologers = async (values) => {
    return await axiosInstance(options).post(`${path}/list-astrologers`, values);
}

export const ManualWithdrawal = async (data) => {
    return await axiosInstance(options).post(`${path}/manual-withdrawal`, data);
}

export const History = async (data = {}) => {
    return await axiosInstance(options).post(`${path}/history`, data);
}

export const Approve = async (data) => {
    return await axiosInstance(options).post(`${path}/approve`, data);
}

export const Reject = async (data) => {
    return await axiosInstance(options).post(`${path}/reject`, data);
}